import { ReactNode } from 'react'

interface Props {
  target: string
}
export function Emphasize({ target }: Props) {
  if (target.indexOf('<em>') === -1) {
    return <>{target}</>
  }
  return (
    <>
      {target.split('<em>').reduce<ReactNode[]>((acc, str, i) => {
        const [before, after] = str.split('</em>')
        if (after) {
          acc.push(<em key={`${i}-${before}`}>{before}</em>)
          acc.push(after)
        } else if (before) {
          acc.push(before)
        }

        return acc
      }, [])}
    </>
  )
}
